module.exports = __webpack_public_path__ + "static/img/110123.43a05554.png";